import { render, staticRenderFns } from "./AddNewField.vue?vue&type=template&id=cb752490&scoped=true&"
import script from "./AddNewField.vue?vue&type=script&lang=js&"
export * from "./AddNewField.vue?vue&type=script&lang=js&"
import style0 from "./AddNewField.vue?vue&type=style&index=0&id=cb752490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb752490",
  null
  
)

export default component.exports